export default __webpack_public_path__ + "static/media/CinzelDecorative-Black.224551d0.ttf";